// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__vX7CA"};